/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Noise from './Noise';

const { sin, PI } = Math;

export default class NoiseSine extends Noise {
	sines = [];

	add(freq, amplitude) {
		const wrap = x => typeof x === 'number' ? () => x : x;
		freq = wrap(freq);
		amplitude = wrap(amplitude);
		this.sines.push([wrap(freq), wrap(amplitude)]);
		return this;
	}

	drive(args) {
		let x = 0;
		const t = args.time.relative * PI;
		for (const [freq, amplitude] of this.sines) {
			x += sin(t * freq(args)) * amplitude(args);
		}
		return x;
	}
}
